import {find, findMany, addClass, removeClass} from '../Libraries/helpers';
//
// const sites = findMany('[data-site]');
//
// sites.forEach(site => {
//     on('click', () => setCookie('site', site.getAttribute('data-site'), 365), site)
// });

findMany('.fader').forEach(container => {
    const stage = find('.stage', container)
    const speed = 5000
    const slides = findMany('.slide', stage)

    const active = () => find('.opacity-100', stage)

    const next = () => {
        let nextSlide = active().nextElementSibling

        if (nextSlide) {
            return nextSlide
        }

        return slides[0]
    }

    const goToNextSlide = () => {
        setTimeout(() => {
            const nextSlide = next()
            const activeSlide = active()

            addClass(nextSlide, 'opacity-100');
            removeClass(nextSlide, 'opacity-0');

            addClass(activeSlide, 'opacity-0');
            removeClass(activeSlide, 'opacity-100');

            goToNextSlide()
        }, speed)
    }

    if (slides.length > 1) {
        goToNextSlide()
    }
})
